import type { DraftDate } from './types'

/** Число дней в месяце с учётом года (для февраля високосных лет). */
export function daysInMonth(month: number, year: number): number {
  return new Date(year, month + 1, 0).getDate()
}

/**
 * Границы `minDate`/`maxDate` раньше обрезали только барабан года — и этого мало. В крайнем
 * году оставались все двенадцать месяцев и все дни, поэтому при `maxDate = сегодня` спокойно
 * выбиралась дата из будущего, а при возрастной границе — возраст на несколько месяцев меньше
 * разрешённого. Отсюда обрезка по месяцу и дню и подтягивание чернового выбора внутрь границ.
 */
function toDraft(date: Date): DraftDate {
  return { day: date.getDate(), month: date.getMonth(), year: date.getFullYear() }
}

/** Отрицательное — `a` раньше `b`, ноль — тот же день. */
function compareDrafts(a: DraftDate, b: DraftDate): number {
  return a.year - b.year || a.month - b.month || a.day - b.day
}

export function resolveMonthBounds(
  year: number,
  minDate: Date,
  maxDate: Date,
): { from: number; to: number } {
  return {
    from: year === minDate.getFullYear() ? minDate.getMonth() : 0,
    to: year === maxDate.getFullYear() ? maxDate.getMonth() : 11,
  }
}

export function resolveDayBounds(
  year: number,
  month: number,
  minDate: Date,
  maxDate: Date,
): { from: number; to: number } {
  const isMinMonth = year === minDate.getFullYear() && month === minDate.getMonth()
  const isMaxMonth = year === maxDate.getFullYear() && month === maxDate.getMonth()

  return {
    from: isMinMonth ? minDate.getDate() : 1,
    to: isMaxMonth ? maxDate.getDate() : daysInMonth(month, year),
  }
}

/**
 * Подтягивает черновой выбор внутрь границ. Нужен и на открытии (значение могло прийти из
 * старых данных или черновика), и после кручения барабанов: смена года или месяца может
 * вынести дату за край, а барабан дня к этому моменту ещё показывает прежнее число.
 */
export function clampDraft(draft: DraftDate, minDate: Date, maxDate: Date): DraftDate {
  const min = toDraft(minDate)
  const max = toDraft(maxDate)

  if (compareDrafts(draft, min) < 0) return min
  if (compareDrafts(draft, max) > 0) return max

  return draft
}
